import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { data } from '../../data';
import { jsPDF } from 'jspdf';
import './Answer.css';
import examsifyshapeimg from '../../assest/ExamSify Shape Png.png';
import downloadsignimg from '../../assest/download Sign.png';
import shapeimg from '../../assest/log in, sign up & answer page png.png';
import searchimg from '../../assest/search icon.png';
import commenticon from '../../assest/Add Answers Icon.png'
import { useNavigate } from 'react-router-dom';

const AnswerPage = () => {
  const { id } = useParams();
  const initialItem = data.find(q => q.id === parseInt(id));
  const navigate =useNavigate()
  const [searchQuery, setSearchQuery] = useState('');
  const [item, setItem] = useState(initialItem);
  const [showPopup, setShowPopup] = useState(false);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setItem(initialItem);
  }, [id]);

  const handleDownloadPDF = () => {
    if (!item) return;

    const doc = new jsPDF();
    doc.setFontSize(14);
    doc.text(`Question:`, 10, 10);
    doc.setFont('bold');
    doc.text(item.question, 10, 20);
    doc.setFont(undefined, 'normal');
    doc.text(`\nAnswer:\n`, 10, 30);
    doc.setFontSize(12);

    const splitText = doc.splitTextToSize(item.answer, 180);
    doc.text(splitText, 10, 40);

    doc.save(`Answer-${item.id}.pdf`);
    setShowPopup(true);
  };

  const handleBackToHome = () => {

    // window.location.href = '/';
    navigate('/')
  };

  const handleSearch = () => {
    if (searchQuery.trim()) {
      const result = data.find(q =>
        q.question.toLowerCase().includes(searchQuery.toLowerCase())
      );
      if (result) {
        setItem(result);
        setNotFound(false);
      } else {
        setItem(null);
        setNotFound(true);
      }
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <>
      <div className='search-wrapper'>
        <img src={examsifyshapeimg} className='shape-png' alt="shape" />
        <div className='search-container'>
          <input
            type="text"
            className="search-page"
            placeholder="Search your question..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            onKeyPress={handleKeyPress}
          />
          <img src={searchimg} className='search-png' alt="search" />
          <span>
            <button className='page-btn' onClick={handleSearch}>Find Solution</button>
          </span>
        </div>
      </div>

      <div className='answer-container'>
        <img src={shapeimg} alt="shape" />
        <div className='answer-wrapper'>
          {item ? (
            <div className="answer-page">
              <h2>{item.question}</h2>
              <p>{item.answer}</p>
               <div className="button-wrapper">
            <Link to={"/submit-request"}>   <button className="question-btn">
<i class="fa-regular fa-comment-dots"></i>    Add Your Solution.
  </button></Link>
              <span>
              <button className='download-btn' onClick={handleDownloadPDF}>Download PDF</button>
              </span>
              </div>
            </div>
          ) : (
            notFound && <p className="no-result">No matching result found.</p>
          )}
        </div>
      </div>

      {showPopup && (
        <div className="custom-popup">
          <div className="popup-content">
            <h2>
              Download Successfully
              <img src={downloadsignimg} alt="downloaded" />
            </h2>
            <div className="popup-buttons">
              {/* <button className="add-btn">
                <i className="fa-regular fa-square-plus"></i>&nbsp;Add New Question Papers
              </button> */}
              <button className="home-btn" onClick={handleBackToHome}>
                &nbsp;  Find More solutions
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AnswerPage;
